import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: '[smrtsNumbersOnly]', standalone: false })
export class NumbersOnlyDirective {

  @Input() allowDecimals: boolean = true;
  @Input() allowNegative: boolean = true;

  constructor(
    private hostElement: ElementRef,
    private ngControl: NgControl
  ) { }

  @HostListener('input')
  onInputChange(): void {
    const initalValue = this.hostElement.nativeElement.value;

    // Remove tudo menos sinal de menos, ponto e números
    let value = initalValue.replace(/,/g, '.').replace(/[^-.0-9]*/g, '');

    // Tratamento do sinal de menos
    let splitedStr = value.split("-");
    if (splitedStr.length > 1) {
      if (splitedStr[0] === "" && this.allowNegative)
        value = "-" + splitedStr.join('');
      else
        value = splitedStr.join('');
    }

    // Tratamento do ponto decimal
    splitedStr = value.split(".");
    if (splitedStr.length > 1) {
      if (this.allowDecimals) {
        if (splitedStr[0] === "")
          value = "0." + splitedStr[1];
        else
          value = splitedStr[0] + "." + splitedStr[1];
        if (splitedStr.length > 2)
          value = value + splitedStr.slice(2).join('');
      }
      else
        value = splitedStr.join('');
    }

    // Atualiza o valor no form control com o número convertido
    if (initalValue !== value) {
      this.ngControl.control!.patchValue(value, { emitEvent: false });
    }
  }
}
